import styled, { css } from 'styled-components'

export const RainbowUnderLineDiv = styled.div<{
  background?: string
  height?: number
  position: 'relative' | 'absolute'
}>`
  width: 100%;
  ${props => css`
    position: ${props.position || 'relative'};
    background: ${props.background || '#00104a'};
    height: ${props.height || 3}px;
  `}
`
export const RainbowUnderlineInDiv = styled.div<{
  width?: number
  left?: number
}>`
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0);
  background: linear-gradient(
    140deg,
    rgba(255, 255, 255, 0) 14%,
    rgba(255, 19, 128, 1) 14%,
    rgba(255, 19, 128, 1) 37%,
    rgba(255, 211, 0, 1) 37%,
    rgba(255, 211, 0, 1) 63%,
    rgba(0, 241, 200, 1) 63%,
    rgba(0, 241, 200, 1) 86%,
    rgba(255, 255, 255, 0) 86%
  );
  max-width: 280px;
  ${props => css`
    width: ${props.width || 20}%;
    left: ${props.left || 20}%;
  `}
`
